export default {
  created () {
    // TODO: This is where we'll load recipe from localstorage

    this.$store.dispatch('workplace/init')
  }
}
